<template>
    <BaseSection
        class="section--link-blocks"
        :class="[header ? 'section--header' : '', largeHeader ? 'section--large-header' : '']"
        :data-width="linkBlocks.length > 2 ? 'page' : 'content'"
        :alignment="headerAlignmentMapped"
    >
        <template
            v-if="header"
            v-slot:title
        >
            {{ header }}
        </template>
        <template
            v-if="subTitle"
            v-slot:subtitle
        >
            {{ subTitle }}
        </template>
        <template
            v-if="description"
            v-slot:description
        >
            <div v-html="description" /><!-- eslint-disable-line -->
        </template>
        <LinkBlocks
            :link-blocks="linkBlocks"
            :background="background"
            :data-count="linkBlocks.length"
        />
    </BaseSection>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
            required: true,
            default: () => { return {}; }
        }
    },
    computed: {
        background() {
            return this?.content?.backgroundColorLight ?? '';
        },
        header() {
            return this?.content?.header ?? '';
        },
        largeHeader() {
            return this?.content?.largeHeader ?? true;
        },
        headerAlignment() {
            return this.content.headerAlignment ?? true;
        },
        headerAlignmentMapped() {
            if (this.headerAlignment) {
                return 'center';
            }
            return 'left';
        },
        subTitle() {
            return this?.content?.subTitle ?? '';
        },
        description() {
            return this?.content?.richTextSimple ?? '';
        },
        linkBlocks() {
            return this?.content?.linkBlocks ?? [];
        }
    }
};
</script>
